import { Brand } from '@blade/std-lib'

import type { Address } from '@root/entities/address/Address'

export const PairAddressTypeId = 'tradebot-tma/PairAddress' as const
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PairAddressTypeId = typeof PairAddressTypeId

export type PairAddress = Brand.Branded<Address, PairAddressTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PairAddress = Brand.nominal<PairAddress>()
